/* eslint-disable no-unused-vars */
import React from 'react';
import { Button, Typography, Grid, Paper, List, ListItem, ListItemText, ListItemIcon, Box } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SubscriptionPlansCarousel from './SubscriptionPlansCarousel';
import ContactUsDialog from './ContactUsDialog';
import { useGetSubscriptionsChoosePlan, useSubscriptionsActiveUpdate } from 'hooks/useSubscriptionsHooks';
import { setToast, toastConfig } from 'utils/commonUtil';
import { useState } from 'react';
import SubscriptionChangeModal from '../SubscriptionChangeModal';
import { useEffect } from 'react';

const PricingTable = ({ value, subcriptionList, callFrom, setOpenViewModal, pageCallFrom }) => {
  const navigator = useNavigate();
  const [openContactUs, setOpenContactUs] = React.useState(false);
  const { mutate: subcriptionActive, loading: isLoadingActive } = useSubscriptionsActiveUpdate();

  const [openChangeSubDialog, setOpenChangeSubDialog] = useState({ show: false, payload: null });

  const [isSubscriptionBtn, setIsSubscriptionBtn] = React.useState({ show: false, id: null });
  const [isChange, setIsChange] = useState({ fire: false, payload: null });
  const [paymentLinkLoading, setPaymentLinkLoading] = useState(false);

  const { data: subscriptionList, isLoading: isLoadingSubscriptionList } = useGetSubscriptionsChoosePlan(
    isChange?.payload?.machineId,
    isChange?.payload?.planId,
    isChange?.fire
  );

  useEffect(() => {
    if (subscriptionList && !isLoadingSubscriptionList) {
      let count = 0;
      if (subscriptionList?.localUsers && subscriptionList?.localUsers?.users && Array.isArray(subscriptionList?.localUsers?.users)) {
        count++;
      }

      if (subscriptionList?.globalUsers && subscriptionList?.globalUsers?.users && Array.isArray(subscriptionList?.globalUsers?.users)) {
        count++;
      }
      if (count > 0) {
        setOpenChangeSubDialog((prev) => ({ ...prev, show: true, payload: isChange?.payload }));
        setIsChange((prev) => ({ ...prev, fire: false }));
      } else {
        addSubscription(isChange?.payload);
      }
    }
  }, [subscriptionList, isLoadingSubscriptionList]);

  const openInNewTab = (url) => {
    if (url) {
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.target = '_blank';
      anchor.rel = 'noopener noreferrer';
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    }
  };

  const addSubscription = (payload) => {
    setIsSubscriptionBtn((prev) => ({ ...prev, show: true, id: payload?.planId }));
    setPaymentLinkLoading(true);
    subcriptionActive(payload, {
      onSuccess: (res) => {
        // const newWindow = window.open('', '_blank', 'noopener');
        // console.log('res - submitData - Employee : ', res);
        if (res?.status === 200) {
          // toastConfig.type = 'success';
          // setToast(toastConfig, res?.data.message);
          // console.log('subcriptionActive : ', res);
          const paymentLink = res?.data?.data?.paymentLink;
          // window.open(paymentLink, '_blank', 'noopener');
          openInNewTab(paymentLink);
          setPaymentLinkLoading(false);
          // window.open(paymentLink, '_blank');
          // console.log('paymentLink', paymentLink);
          // if (paymentLink)
          // newWindow.location = paymentLink;
          // else newWindow.close();

          if (!callFrom) {
            navigator('/dashboard/machines?viewMachineID=' + value?.machineId + '&viewSub=true');
          } else if (callFrom && callFrom === 'Employee') {
            //Pass
            // console.log('call from  : ', callFrom, ' | machineId : ', value?.machineId);
            setOpenViewModal((state) => ({
              ...state,
              open: false,
              machineId: null,
              openSubscription: false,
              machineSubFromEmployee: null
            }));
          }
        } else {
          toastConfig.type = 'error';
          setToast(toastConfig, error?.response?.data?.error);
          // newWindow.close();
          setPaymentLinkLoading(false);
        }
        setIsSubscriptionBtn((prev) => ({ show: false, id: null }));
      },
      onError: (error) => {
        toastConfig.type = 'error';
        setToast(toastConfig, error?.response?.data?.error);
        setIsSubscriptionBtn((prev) => ({ show: false, id: null }));
        setPaymentLinkLoading(false);
        // newWindow.close();
      }
    });
  };

  const callInvoiceScreen = (id = '', setIsSubscriptionBtn) => {
    const payload = {
      machineId: value?.machineId || null,
      planId: id || null
    };
    // console.log('callInvoiceScreen | id', id, value, ' | payload : ', payload);
    if (pageCallFrom === 'add') {
      addSubscription(payload);
    } else if (pageCallFrom === 'change') {
      // setOpenChangeSubDialog((prev) => ({ ...prev, show: true, payload }));
      setIsChange((prev) => ({ ...prev, fire: true, payload }));
    }
    // navigate('/dashboard/machines/create-invoice', {
    //   state: {
    //     machineObj: value,
    //     subId: id,
    //     subObj: subcriptionList && subcriptionList.length > 0 ? subcriptionList.filter((sub) => sub.id === id) : null
    //   }
    // });
  };

  // const carouselItems = [<div key="1">Slide 1 Content</div>, <div key="2">Slide 2 Content</div>, <div key="2">Slide 3 Content</div>];
  return (
    <>
      <Grid container spacing={3} justifyContent="center" sx={{ mt: 'unset' }}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          {/* <Typography variant="h2" align="left" sx={{ fontWeight: 'bold', paddingBottom: 'unset', color: '#000' }}>
            Choose Subscription
          </Typography> */}
          <Typography className="skip-heading" component="h4" variant="h2" sx={{ mb: 2 }}>
            Choose Subscription
          </Typography>
        </Grid>
        {/* <Grid item xs={12} sm={12} md={12} lg={12}>
          <Box
            className="skip-btn"
            sx={{
              position: 'absolute', // Position the button absolutely
              right: 20, // Space from the right edge of the page
              top: '5%', // Vertically center the button
              // transform: 'translateY(-50%)', // To perfectly center the button
              zIndex: 1000 // Ensure it is on top of other elements
            }}
          >
            <Button
              onClick={() => callInvoiceScreen('')}
              variant="contained"
              color="primary"
              endIcon={<SkipNextIcon />}
              sx={{ color: '#fff', fontWeight: 'unset', marginBottom: '20px' }}
            >
              Skip Subscription
            </Button>
          </Box>
        </Grid> */}
      </Grid>

      <SubscriptionPlansCarousel
        subcriptionList={subcriptionList}
        callInvoiceScreen={callInvoiceScreen}
        setOpenContactUs={setOpenContactUs}
        openContactUs={openContactUs}
        value={value}
        isSubscriptionBtn={isSubscriptionBtn}
        setIsSubscriptionBtn={setIsSubscriptionBtn}
      />

      {openContactUs && <ContactUsDialog open={openContactUs} setOpen={setOpenContactUs} machineObj={value} />}

      {openChangeSubDialog.show && (
        <SubscriptionChangeModal
          open={openChangeSubDialog?.show || false}
          setOpen={setOpenChangeSubDialog}
          payload={openChangeSubDialog?.payload || null}
          addSubscription={addSubscription}
          setIsSubscriptionBtn={setIsSubscriptionBtn}
          subscriptionList={subscriptionList}
          // isLoadingSubscriptionList={isLoadingSubscriptionList}
          isLoadingSubscriptionList={paymentLinkLoading}
        />
      )}
    </>
  );
};

export default PricingTable;
